import { WaterTypeBase } from './base/water-type-base';

export class WaterType extends WaterTypeBase { }